module.exports = __webpack_public_path__ + "img/alex_competencies.830cdcc2.svg";